import {getDefaultPieFormatting} from '@/containers/E4ImpactMBA/charts/pie';
import {getSubmissions} from '@/containers/E4ImpactProjects/TabSections/Output/filterByEmployees';

const transform = [
    {
        name: 'Women',
        value: 'totalCountFemale',
        color: '#5b9bd5',
    },
    {
        name: 'Men',
        value: 'totalCountMale',
        color: '#ed7d32',
    },
];

/**
 * Survey: PROJECT - BASELINE IMPACT
 * Question: How many people does your business currently employ?
 * 
 * == baseline
 * jobs_t0_men_t0_number
 * jobs_t0_women_t0_number
 * 
 * Survey: PROJECT- FINAL IMPACT
 * Question: How many people does your business employ?
 * 
 * == final
 * jobs_t1_men_t1_number
 * jobs_t1_women_t1_number
 * 
 * @param props 
 * @returns 
 */
export const newJobsByGenderChartCalculation = (props: any) => {
    const positiveSubmissions = getSubmissions(props);

    const calculateDifferences = (baselineKey: string, finalKey: string) => {
        const baselineTotalEmployees = positiveSubmissions.reduce(function (acc: number, {baselineSubmission}: any) {
            return acc + (Number(baselineSubmission[baselineKey]) || 0);
        }, 0);
        const finalTotalEmployees = positiveSubmissions.reduce(function (acc: number,{finalSubmission}: any) {
            return acc + (Number(finalSubmission[finalKey]) || 0);
        }, 0);

        return finalTotalEmployees - baselineTotalEmployees;
    };

    const totalCountFemale = calculateDifferences('jobs_t0_women_t0_number', 'jobs_t1_women_t1_number');
    const totalCountMale = calculateDifferences('jobs_t0_men_t0_number', 'jobs_t1_men_t1_number');
    
    const data = transform.map((el) => ({
        name: el.name,
        color: el.color,
        y: el.value === 'totalCountFemale' ? totalCountFemale : totalCountMale,
    }));
    
    return getDefaultPieFormatting(
        'KPI: New jobs by gender',
        data
    ) as Highcharts.Options;
}